import { useBatchSkiptraceStore } from 'features/BatchSkiptrace/infra/views/BatchSkiptraceStore/BatchSkiptraceStoreLive'

/**
 * Hook to access the confirmBatchSkiptrace state from the BatchSkiptraceStore
 */
export const useConfirmBatchSkiptraceState = () =>
  useBatchSkiptraceStore(store => store.confirmBatchSkiptrace.state)
